import formValidator, {
	required,
	isCorrectEmailLen,
	maxLen,
	isEmail,
	and,
} from "@insightfulscience/shared-utils/validation";

export const initialState = {
	email: "",
	firstName: "",
	lastName: "",
	organization: "",
	position: "",
	countrySelect: "",
};

const schema = {
	email: [
		[required, "errors.EMAIL_REQUIRED"],
		[isCorrectEmailLen(64), "errors.EMAIL_INVALID_LENGTH"],
		[email => isEmail(email), "errors.EMAIL_INVALID"],
		[maxLen(100), "errors.WRONG_EMAIL"],
	],
	firstName: [required, "errors.FIRST_NAME_REQUIRED"],
	lastName: [required, "errors.LAST_NAME_REQUIRED"],
	organization: [required, "errors.ORGANIZATION_REQUIRED"],
	position: [required, "errors.POSITION_REQUIRED"],
	countryID: [and(required, value => value > 0), "errors.COUNTRY_REQUIRED"],
};

export const validateForm = formValidator(schema);
